import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ProductCategoryService', ProductCategoryService);

  ProductCategoryService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'TranslationModalService',
    'ProductCategoryModalService',
  ];

  function ProductCategoryService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    TranslationModalService,
    ProductCategoryModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'product_categories';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getProductCategories: getProductCategories,
      getProductCategory: getProductCategory,
      saveProductCategory: saveProductCategory,
      openProductCategoryTranslations: openProductCategoryTranslations,
      changeProductCategoryStatus: changeProductCategoryStatus,
      deleteProductCategory: deleteProductCategory,
      openProductCategoriesModal: openProductCategoriesModal,
      applyAssociatedTaxes: applyAssociatedTaxes,
      applyPrepaymentSettings: applyPrepaymentSettings,
      applyAccounting: applyAccounting,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getProductCategories(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getProductCategory(id, language, translate) {
      var params;

      if (language) {
        params = {
          lang: language,
        };
      }

      if (translate) {
        params.get = 'translate';
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveProductCategory(item, language) {
      let method = 'post';
      let url = apiUrl;

      if (item.id) {
        // edit
        method = 'put';
        url += '/' + item.id;
      }

      let lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      return RestResource.request(
        method,
        url,
        { product_category: item, lang: lang },
        function (response) {
          let msg = item.id ? 'MODIFIED_PRODUCT_CATEGORY' : 'NEW_ADDED_PRODUCT_CATEGORY';
          utils._successMsg($translate(msg));

          return {
            status: true,
            response: response.data,
          };
        },
        function failure(response) {
          return {
            status: false,
            response: response.data,
          };
        }
      );
    }

    function openProductCategoryTranslations(item, additionalLanguages) {
      var template = './app/ajs/product-categories/modals/product-category-detail-translation.html';

      var modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getProductCategory(itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (item, language) {
        return saveProductCategory(item, language).then(function (data) {
          if (!data.status) {
            return data;
          }
          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function changeProductCategoryStatus(item, successCallback) {
      let params = {
        title: 'DEACTIVATE_PRODUCT_CATEGORY',
        body: 'DEACTIVATE_PRODUCT_CATEGORY_WARNING',
        requireConfirmation: true,
        successMsg: 'PRODUCT_CATEGORY_DEACTIVATED',
      };

      utils.changeItemStatus(apiUrl + '/' + item.id, item, params, successCallback);
    }

    function deleteProductCategory(item, successCallback) {
      let params = {
        title: 'DELETE_PRODUCT_CATEGORY',
        body: 'DELETE_PRODUCT_CATEGORY_WARNING',
        mode: 'danger',
        requireConfirmation: true,
        successMsg: 'PRODUCT_CATEGORY_DELETED',
      };

      let url = apiUrl + '/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function openProductCategoriesModal(getItemsCallback) {
      ProductCategoryModalService.openProductCategories(getItemsCallback);
    }

    function applyAssociatedTaxes(productCategory, apply_taxes) {
      let url = apiUrl + '/' + productCategory.id + '/apply_associated_taxes';

      if (apply_taxes) {
        url += '?apply_taxes=true';
      }

      return RestResource.request(
        'put',
        url,
        { product_category: productCategory },
        function (response) {
          if (apply_taxes) {
            utils._successMsg($translate('TAXES_APPLIED'));
          }
          return response.data;
        },
        function (response) {
          utils._errorMsg(response.data.errors);
          return false;
        }
      );
    }

    function applyPrepaymentSettings(item) {
      let url = `${apiUrl}/${item.id}`;
      return RestResource.request(
        'put',
        url,
        { product_category: item },
        function (response) {
          utils._successMsg($translate('PREPAYMENT_SETTINGS_APPLIED'));
          return response.data;
        },
        function (response) {
          utils._errorMsg(response.data.errors);
          return false;
        }
      );
    }

    function applyAccounting(item) {
      let url = `${apiUrl}/${item.id}`;

      return RestResource.request(
        'put',
        url,
        { product_category: item },
        function (response) {
          utils._successMsg($translate('ACCOUNTING_APPLIED'));
          return response.data;
        },
        function (response) {
          utils._errorMsg(response.data.errors);
          return false;
        }
      );
    }
  }
})();
